import axios from 'axios';
import { axiosRateLimit } from 'lib/AxiosRateLimiter';
import moment from 'moment';

const baseUrl = '/api/v2';
const defaultConfig = {_hideErrors: true};
let http;

/**
 *
 * @param preferences {{any}}
 * @param reportType {string}
 * @returns {Promise<AxiosResponse<any>[]>}
 */
async function updateV2Preferences(preferences, reportType) {
    if (!http) {
        http = axiosRateLimit();
    }
    const url = `${baseUrl}/preferences/${reportType}`;
    const body = Object.entries(preferences).map(([key, value]) => ({
        key,
        value,
        created: moment.utc().toISOString(),
    }));
    return http?.put(url, body, defaultConfig);
}

/**
 *
 * @param reportType
 * @param shouldValidate
 * @returns {Promise<{data: {key: string, value: string, created: string}[]}>}
 */
function getV2Preferences(reportType, shouldValidate = true) {
  let url = `${baseUrl}/preferences/${reportType}`;
  let params = {shouldValidate};
  return axios.get(url, {params});
}

export { http, updateV2Preferences, getV2Preferences };